import '../styles/woriva-logo.css';

export default function WorivaLogo() {
  return <span className="woriva-logo" role="img" aria-label="Woriva">
    <span className="woriva-logo-mark"><img src="/brand/woriva-w.png" alt="" /></span>
    <span className="woriva-logo-word"><img src="/brand/woriva-wordmark.png" alt="" /></span>
  </span>;
}
